/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { FC, Dispatch, SetStateAction } from 'react';
import moment from 'moment';
import clsx from 'clsx';
import { DatePicker, Select } from '@td-client-frontend/common';
import { CircleCheckSimple, CloseCircle } from '@td-client-frontend/icons';
import { PlansOption } from '../interfaces/PlanIntrfaces';
import PlansCheckbox from './PlansCheckbox';
import { planDateFormatter } from '../../../../utils/plansModalUtils';

interface PlansHeaderProps {
  showAddNewPlan: boolean;
  actionOptions: PlansOption[];
  selectedValue: string | null;
  setSelectedValue: Dispatch<SetStateAction<string | null>>;
  selectDisabled: boolean;
  showCheckbox: boolean;
  checkedAllStatus: boolean;
  multiDateValue: string;
  setMultiDateValue: Dispatch<SetStateAction<string>>;
  multiDateValueError: string;
  showMultiEdit: boolean;
  saveMultiEditedDate: () => void;
  setCheckedAllStatus: () => void;
  cancelHandler: () => void;
}

const PlansHeader: FC<PlansHeaderProps> = ({
  showAddNewPlan,
  actionOptions,
  selectedValue,
  setSelectedValue,
  selectDisabled,
  showCheckbox,
  checkedAllStatus,
  setCheckedAllStatus,
  multiDateValue,
  setMultiDateValue,
  multiDateValueError,
  saveMultiEditedDate,
  showMultiEdit,
  cancelHandler
}) => {
  const headerStyle = 'py-4 text-left text-gray-default text-sm font-medium font-effra';

  const dateEditHandler = (date) => {
    const validDate = planDateFormatter(date);
    setMultiDateValue(validDate);
  };

  const selectOption = showMultiEdit ? actionOptions.filter((option) => option.value !== 'delete') : actionOptions;

  return (
    <>
      <div
        className="w-full mt-3 grid gap-4 items-center"
        style={{
          gridTemplateColumns: '1.5fr repeat(2, minmax(0, 1fr))'
        }}
      >
        {!showAddNewPlan && showCheckbox && (
          <Select
            name="Select Actions"
            options={selectOption}
            value={selectedValue}
            placeholder="Actions"
            onChange={setSelectedValue}
            maxVisible={3}
            required={false}
            labelBtn={false}
            isDisabled={selectDisabled}
            fieldLabelClasses="hidden"
            errorClassName={!multiDateValueError ? 'hidden' : ''}
          />
        )}
        {showMultiEdit && (
          <>
            <DatePicker
              value={moment(multiDateValue).isValid() ? moment(multiDateValue).format('MM/DD/YYYY') : ''}
              placeholder="MM/DD/YYYY"
              label=""
              onChange={dateEditHandler}
              error={multiDateValueError}
              isError={multiDateValueError}
              errorClassName={!multiDateValueError ? 'hidden' : ''}
              fieldLabelClasses="hidden"
            />
            <div className="h-full pt-2">
              <button onClick={saveMultiEditedDate} className="focus:outline-none active:outline-none mr-5">
                <CircleCheckSimple color="#167F01" />
              </button>
              <button onClick={cancelHandler} className="focus:outline-none active:outline-none">
                <CloseCircle className="stroke-current text-red-700 cursor-pointer" />
              </button>
            </div>
          </>
        )}
      </div>
      <div
        className="grid gap-4 items-center border-b-1 border-gray-20"
        style={{
          gridTemplateColumns: showMultiEdit
            ? '1.5fr repeat(2, minmax(0, 1fr))'
            : showAddNewPlan
            ? '2fr repeat(2, minmax(0, 1fr)) 0.5fr'
            : '0.5fr 2fr repeat(2, minmax(0, 1.5fr)) 0.5fr'
        }}
      >
        {!showAddNewPlan && !showMultiEdit && (
          <PlansCheckbox
            checkedValue={checkedAllStatus}
            onCheckedChange={setCheckedAllStatus}
            showCheckbox={showCheckbox}
          />
        )}
        <h3 className={clsx(headerStyle, showMultiEdit && 'text-right mr-7')}>CODE</h3>
        <h3 className={headerStyle}>EFFECTIVE DATE</h3>
        <h3 className={headerStyle}>TERMINATION DATE</h3>
      </div>
    </>
  );
};

export default PlansHeader;
